import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class AnimationEffects extends BaseOption {
  static animationTriggers = [
    {
      id: "onAppear",
      name: "On Appear",
    },
    {
      id: "onClick",
      name: "On Click",
    },
    {
      id: "onHover",
      name: "On Hover",
    },
    {
      id: "onEvent",
      name: "On Event",
    },
    {
      id: "mouseenter",
      name: "Mouse Enter",
    },
    {
      id: "mouseleave",
      name: "Mouse Leave",
    },
    {
      id: "clickoutside",
      name: "Click Outside",
    },
    {
      id: "onDoubleClick",
      name: "On Double Click / Double Tap",
    },
    {
      id: "onLongPress",
      name: "On Right Click / Long Press",
    },
    {
      id: "onSwipeLeft",
      name: "On Swipe Left",
    },
    {
      id: "onSwipeRight",
      name: "On Swipe Right",
    },
    {
      id: "onSwipeUp",
      name: "On Swipe Up",
    },
    {
      id: "onSwipeDown",
      name: "On Swipe Down",
    },
    {
      id: "onPinch",
      name: "On Pinch",
    },
    {
      id: "onSpread",
      name: "On Spread",
    },
    {
      id: "onRotateLeft",
      name: "On Rotate Left",
    },
    {
      id: "onRotateRight",
      name: "On Rotate Right",
    },
  ];

  static triggerEventOption = {
    "trigger-event": {
      custom: true,
    },
  };

  static defaultAnimationOptions = {
    "fade-in": {
      duration: 400,
      delay: 0,
      timingFunction: "ease-out",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0 },
    },
    "slide-in-from-left": {
      duration: 500,
      delay: 0,
      timingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "translateX(-50px)" },
    },
    "slide-in-from-right": {
      duration: 500,
      delay: 0,
      timingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "translateX(50px)" },
    },
    "bounce-in": {
      duration: 600,
      delay: 0,
      timingFunction: "cubic-bezier(0.34, 1.56, 0.64, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "scale(0.3)" },
    },
    "slide-down": {
      duration: 450,
      delay: 0,
      timingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "translateY(-40px)" },
    },
    "slide-up": {
      duration: 450,
      delay: 0,
      timingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "translateY(40px)" },
    },
    "scale-in": {
      duration: 350,
      delay: 0,
      timingFunction: "cubic-bezier(0.2, 0, 0, 1)",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, transform: "scale(0.65)" },
    },
    "image-blur-in": {
      duration: 800,
      delay: 100,
      timingFunction: "ease-out",
      iteration: 1,
      direction: "normal",
      initialState: { opacity: 0, filter: "blur(20px)", transform: "scale(1.1)" },
    },
    "focus-drift": {
      duration: 1200,
      delay: 0,
      timingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
      iteration: 1,
      direction: "normal",
      initialState: {
        opacity: 0,
        filter: "blur(8px)",
        transform: "scale(1.02) translateY(10px)",
      },
    },
  };

  static hoverAnimationOptions = {
    "soft-scale": {
      duration: 200,
      delay: 0,
      timingFunction: "cubic-bezier(0.33, 1, 0.68, 1)",
      effect: {
        transform: "scale(1.05)",
        opacity: 1,
        filter: "none",
      },
    },
    "micro-lift": {
      duration: 150,
      delay: 0,
      timingFunction: "cubic-bezier(0.25, 1, 0.5, 1)",
      effect: {
        transform: "translateY(-4px)",
        opacity: 1,
        filter: "none",
      },
    },
    "micro-compress": {
      duration: 120,
      delay: 0,
      timingFunction: "ease-out",
      effect: {
        transform: "scale(0.97)",
        opacity: 1,
        filter: "none",
      },
    },
    "lift-scale": {
      duration: 250,
      delay: 0,
      timingFunction: "cubic-bezier(0.34, 1.56, 0.64, 1)",
      effect: {
        transform: "scale(1.03) translateY(-6px)",
        opacity: 1,
        filter: "none",
      },
    },
  };

  static eventTriggerSettings = [
    { id: "triggered-event", label: "Triggered Event" },
  ];

  static hoverAnimationSettings = [
    { id: "duration", label: "Duration", unit: "ms" },
    { id: "delay", label: "Delay", unit: "ms" },
    { id: "timingFunction", label: "Timing Function", unit: "" },
    { id: "effect", label: "", unit: "" },
  ];

  static defaultAnimationSettings = [
    { id: "duration", label: "Duration", unit: "ms" },
    { id: "delay", label: "Delay", unit: "ms" },
    { id: "timingFunction", label: "Timing Function", unit: "" },
    { id: "iteration", label: "Iteration", unit: "" },
    { id: "autoReset", label: "Auto Reset", type: "checkbox", default: false },
    { id: "removeWhenInvisible", label: "Remove When Invisible", type: "checkbox", default: false },
    { id: "initialState", label: "", unit: "" },
  ];

  static initialStateProperties = [
    { id: "opacity", label: "Opacity", unit: "", type: "number", step: "any", min: 0, max: 1 },
    { id: "scale", label: "Scale", unit: "", type: "number", step: "any", min: 0 },
    { id: "rotate", label: "Rotate", unit: "deg", type: "number" },
    { id: "offsetX", label: "Offset X", unit: "px", min: -5000, max: 5000, type: "number" },
    { id: "offsetY", label: "Offset Y", unit: "px", min: -5000, max: 5000, type: "number" },
    { id: "blur", label: "Blur", unit: "px", type: "number" },
  ];

  static userInterfaceComponent = () => {
    return {
      component: inspectorTools.ANIMATIONS_EFFECTS_TOOL_SET,
      ignoreDefaultIfNotSetForState: [BaseOption.$states.HOVER],
      props: {
        title: "Effects",
      },
    };
  };

  static defaultValue = {};
}
